import defineSelectorsOf from '../core/define-selectors-of'

/**
 * @type {SelectorFactory<import('./state').OfficialStoreState>}
 */
const defineSelector = defineSelectorsOf('officialStore')

export const getNamePage = defineSelector((state) => (!!state.storeData ? '/zapimoveis/imobiliaria/loja-oficial' : '/zapimoveis/imobiliaria'))
